import { Record } from 'immutable';

const defaults = {
    "firstClass": false,
    "firstClassMeal": false,
    "firstClassRestaurant": false,
    "hotFood": false,
    "buffet": false,
    "restaurant": false,
    "trolley": false,
    "wheelchair": false
};

class Facilities extends Record(defaults) { // eslint-disable-line new-cap

    static fromJSON (json = {}) {
        return new Facilities(json);
    }

}

export default Facilities;



// WEBPACK FOOTER //
// ./src/records/Facilities.js